module.exports = __webpack_public_path__ + "static/img/pic3_m.be7bd4b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pic3_m.png
// module id = zuGP
// module chunks = 1